import React from 'react';
import Header from '../components/Header';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

function Terms() {
  const [user] = useAuthState(auth);

  return (
    <div id="general_screen" className="d-flex align-items-center flex-column mb-0 px-3 main_screen dashboard_screen">
      <Header user={user} />
      <style>{`#general_screen h2 { font-size: 1.4rem; } #general_screen a { color: #fff; }`}</style>
      <div className="container mt-5">
        <h1>Terms and Conditions</h1>
        <p><strong>Effective Date:</strong> May 29th, 2025</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By using our movie rating service, you agree to these Terms of Service. If you don't agree with these terms, please don't use our service.</p>

        <h2>2. Service Description</h2>
        <p>Our service allows you to:</p>
        <ul>
          <li>Create an account with your name and email</li>
          <li>Add your favorite movies to your personal collection</li>
          <li>Rate movies on a scale of 1 to 5 stars</li>
          <li>View and manage your movie ratings</li>
        </ul>

        <h2>3. Account and Usage Limits</h2>
        <ul>
          <li><strong>Free Service:</strong> Our service is currently provided free of charge</li>
          <li><strong>Movie Limit:</strong> Free accounts are limited to 100 movies maximum</li>
          <li><strong>Future Paid Options:</strong> We plan to offer paid upgrades that will allow you to store up to 500 or 1,000 movies for a small fee</li>
          <li><strong>Account Security:</strong> You are responsible for keeping your login credentials secure</li>
        </ul>

        <h2>4. User Data</h2>
        <ul>
          <li>We collect only your name and email address for account creation</li>
          <li>Your movie ratings and preferences are stored securely</li>
          <li>We will not share your personal information with third parties without your consent</li>
          <li>You can request deletion of your account and data at any time</li>
        </ul>

        <h2>5. Acceptable Use</h2>
        <ul>
          <li>Provide accurate information when creating your account</li>
          <li>Use the service only for personal, non-commercial purposes</li>
          <li>Not attempt to exceed the stated movie limits through technical means</li>
          <li>Not interfere with or disrupt the service</li>
        </ul>

        <h2>6. Service Availability</h2>
        <ul>
          <li>We strive to keep the service available but cannot guarantee 100% uptime</li>
          <li>We may temporarily suspend the service for maintenance or updates</li>
          <li>We reserve the right to modify features or limits with reasonable notice</li>
        </ul>

        <h2>7. Changes to Terms</h2>
        <p>We may update these Terms of Service from time to time. We'll notify users of significant changes via email or through the app.</p>

        <h2>8. Termination</h2>
        <p>You may stop using our service at any time. We may suspend or terminate accounts that violate these terms.</p>

        <h2>9. Limitation of Liability</h2>
        <p>Our service is provided "as is" without warranties. We are not liable for any damages arising from your use of the service.</p>

        <h2>10. Contact</h2>
        <p>If you have questions about these Terms of Service, please contact us at <a href="mailto:simone@lamorbidamacchina.com">simone@lamorbidamacchina.com</a>.</p>

        <hr />
        <p><em>Last updated:  May 29th, 2025</em></p>
      </div>
    </div>
  );
}

export default Terms; 